import { render } from "./SecaoParallax.vue?vue&type=template&id=56996574&scoped=true"
import script from "./SecaoParallax.vue?vue&type=script&lang=js"
export * from "./SecaoParallax.vue?vue&type=script&lang=js"

import "./SecaoParallax.vue?vue&type=style&index=0&id=56996574&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56996574"]])

export default __exports__